module.exports = __webpack_public_path__ + "images/2c7929995d9a424c7634409a35bdc123.png";